module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"Link","status":"Status","viewError":"View error"}}')
  delete Component.options._Ctor
}
